var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPermissionsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 39.993,
    viewBox: "0 0 40 39.993",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_184",
    "data-name": "Rechteck 184",
    width: 40,
    height: 39.993,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_302",
    "data-name": "Gruppe 302",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_301",
    "data-name": "Gruppe 301",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_460",
    "data-name": "Pfad 460",
    d: "M7.046,39.993H0V33.087L19.615,14.051a10.493,10.493,0,1,1,5.86,6.15l-2.19,2.189h-2.7v4.362h-4.27v3.706H12V34.59H7.046ZM2,37.993H5.046v-5.4H10V28.458h4.315V24.752h4.27V20.39h3.868l2.6-2.6.644.322A8.407,8.407,0,0,0,29.5,19,8.5,8.5,0,1,0,21,10.5a8.42,8.42,0,0,0,.708,3.4l.278.636L2,33.932Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_461",
    "data-name": "Pfad 461",
    d: "M32,11a3,3,0,1,1,3-3,3,3,0,0,1-3,3m0-4a1,1,0,1,0,1,1,1,1,0,0,0-1-1",
    fill: "#1d1d1b"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPermissionsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Permissions_icon.1fd6582a2c92c3fa86cc26b1a9f7cf08.svg";